import { useState, useCallback } from "react";
import AuthProvider from "../services/auth/AuthProvider/Index";
import { useIdentityPrefill } from "../hooks/useIdentityPrefill";
import { useTwoStepChange } from "../hooks/useTwoStepChange";
import TwoStepChangePage from "./TwoStepChangePage";

const EmailChange = () => {
  const [currentEmail, setCurrentEmail] = useState("");
  const [email, setEmail] = useState("");
  const [token, setToken] = useState("");
  const handleIdentity = useCallback((identity: any) => {
    setCurrentEmail(identity.email);
  }, []);

  const { loadingIdentity } = useIdentityPrefill(handleIdentity);

  const {
    loading,
    requested,
    formErrors,
    handleRequest,
    handleConfirm,
  } = useTwoStepChange({
    requestUrl: `${process.env.REACT_APP_API_BASE_URL}/v1/private/identity/me/email-change-request`,
    confirmUrl: `${process.env.REACT_APP_API_BASE_URL}/v1/private/identity/me/email`,
    buildRequestBody: () => ({ email }),
    buildConfirmBody: () => ({ email, token }),
    requestSuccessMessage:
      "Your email change request has been successfully processed. Please take a moment to check your new email for the confirmation token.",
    confirmSuccessMessage: "Your email has been successfully changed.",
    onConfirmSuccess: async () => {
      const identity = await AuthProvider.getIdentity();
      if (identity) {
        setCurrentEmail(identity.email);
      }
      setEmail("");
      setToken("");
    },
  });

  return (
    <TwoStepChangePage
      title="Email change"
      breadcrumbLabel="Email change"
      currentLabel="Current email address"
      currentValue={currentEmail}
      newLabel="New email address"
      newFieldName="email"
      newValue={email}
      setNewValue={setEmail}
      newInputMask={(inputText: string) => inputText.replaceAll(/[^a-zA-Z0-9.\-_@]/g, "")}
      confirmLabel="Confirmation token"
      confirmFieldName="token"
      tokenValue={token}
      setTokenValue={setToken}
      requested={requested}
      loading={loading}
      loadingIdentity={loadingIdentity}
      formErrors={formErrors}
      onRequest={handleRequest}
      onConfirm={handleConfirm}
      requestButtonLabel="Request email change"
      confirmButtonLabel="Confirm email change"
    />
  );
};

export default EmailChange;
